<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Pedidos para hoy y procesados</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Pedidos para hoy y procesados</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<section class="content">
    <div class="container-fluid">
        <div class="row  justify-content-center">
            <div class="col-xl-10 col-lg-12">
                <app-lista-pedidos label="Entregas para hoy" (updateData)="getDataHoy()" [rows]="rowsHoy"
                    [tempRows]="rowsHoy" [isLoading]="isLoadingHoy" [sortByKey]="'id_pedido'" [reverseSort]="false"></app-lista-pedidos>
            </div>
            <div class="col-xl-10 col-lg-12">
                <app-lista-pedidos label="Pedidos Procesados" (updateData)="getData()" [rows]="rowsProcesados" [sortByKey]="'id_pedido'" [reverseSort]="false"
                    [tempRows]="rowsProcesados" [isLoading]="isLoadingProcesados"></app-lista-pedidos>
            </div>
        </div>
    </div>
</section>